import { RootStore } from "./RootStore"
import { createContext, useContext } from "react"

export const RootStoreContext = createContext<RootStore | null>(null)

export const useStore = () => {
  const context = useContext(RootStoreContext)
  if (context === null) {
    throw new Error("Root component not wrapped with RootStoreProvider")
  }
  return context
}
